<template>
  <div class="admin-dashboard">
    <div class="page-header">
      <h1>管理员后台管理</h1>
      <div style="display: grid; grid-template-columns: auto auto auto; gap: 10px; height: 100%; align-items: top;">
        <button class="auth-btn" style="height: 69px; padding: 6px 12px;" @click="goToSearch">首页</button>

        <!-- 消息和问题反馈按钮组 -->
        <div class="message-feedback-group" style="display: flex; flex-direction: column; gap: 5px;">
          <!-- 消息通知按钮 -->
          <button class="auth-btn message-btn" style="background-color: #2196F3; position: relative; width: 100%; height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="showMessageModal = true">
            消息
            <span v-if="unreadMessageCount > 0" class="message-badge">{{ unreadMessageCount }}</span>
          </button>

          <!-- 问题反馈按钮 -->
          <button class="auth-btn feedback-btn" style="background-color: #ff9800; width: 100%; height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="showFeedbackModal = true">问题反馈</button>
        </div>

        <div v-if="isLoggedIn" class="user-auth-group" style="display: flex; flex-direction: column; gap: 5px;">
          <button class="username auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2; position: relative;">
            {{ username }}
            <!-- 用户身份角标：优先级 超级管理员 > 管理员 > 规划师 > VIP -->
            <span v-if="userVipInfo || isSuperAdmin === '超级管理员' || isSuperAdmin === '管理员'" class="user-badge">
              <template v-if="isSuperAdmin === '超级管理员'">S管理员</template>
              <template v-else-if="isSuperAdmin === '管理员' || (userVipInfo && userVipInfo.is_admin == true)">管理员</template>
              <template v-else-if="userVipInfo && userVipInfo.is_svip == true">规划师</template>
              <template v-else-if="userVipInfo && userVipInfo.is_vip == true">VIP</template>
            </span>
          </button>
          <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="logout">退出登录</button>
        </div>
        <div v-else class="user-auth-group" style="display: flex; flex-direction: column; gap: 5px;">
          <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="goToLogin">登录</button>
          <button class="auth-btn" style="height: 32px; padding: 6px 12px; margin: 0; box-sizing: border-box; line-height: 1.2;" @click="goToRegister">注册</button>
        </div>
      </div>
    </div>
    
    <div class="dashboard-content">
      <div class="dashboard-cards">
        <div class="card">
          <div class="card-header">
            <h3>用户总数</h3>
          </div>
          <div class="card-content">
            <div class="card-value">{{ userCount }}</div>
            <div class="card-description">
              系统注册用户
              <span v-if="isSuperAdmin === '超级管理员' && userBaseCount > 0" style="color: #909399; font-size: 12px;">(含基数{{ userBaseCount }})</span>
            </div>
            <button v-if="isSuperAdmin === '超级管理员'" class="btn btn-small" @click="openUserBaseDialog" style="margin-top: 8px; padding: 3px 10px; font-size: 12px;">设置基数</button>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header">
            <h3>院校总数</h3>
          </div>
          <div class="card-content">
            <div class="card-value">{{ schoolCount }}</div>
            <div class="card-description">系统收录院校</div>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header">
            <h3>专业总数</h3>
          </div>
          <div class="card-content">
            <div class="card-value">{{ majorCount }}</div>
            <div class="card-description">系统收录专业</div>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header">
            <h3>最新数据年份</h3>
          </div>
          <div class="card-content">
            <div class="card-value">{{ lastUpdate }}</div>
            <div class="card-description">系统最新录取数据年份</div>
          </div>
        </div>

      <!-- 用户基数设置弹窗 -->
      <div v-if="showUserBaseDialog" class="modal-overlay" @click.self="showUserBaseDialog = false">
        <div class="modal">
          <div class="modal-header">
            <h3>设置用户基数</h3>
            <button class="close-btn" @click="showUserBaseDialog = false">×</button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>当前实际用户数</label>
              <input type="number" :value="actualUserCount" disabled style="background-color: #f5f7fa;">
            </div>
            <div class="form-group">
              <label>用户基数</label>
              <input type="number" v-model="editUserBaseCount" min="0" placeholder="请输入基数">
              <div style="font-size: 12px; color: #909399; margin-top: 5px;">
                显示用户数 = 实际用户数({{ actualUserCount }}) + 基数
              </div>
            </div>
            <div class="form-group">
              <label>预览显示用户数</label>
              <input type="number" :value="actualUserCount + (parseInt(editUserBaseCount) || 0)" disabled style="background-color: #f5f7fa; color: #409eff; font-weight: bold;">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn" @click="showUserBaseDialog = false">取消</button>
            <button class="btn btn-primary" @click="saveUserBaseCount">保存</button>
          </div>
        </div>
      </div>

      <!-- 会员卡生成弹窗（通用，支持VIP、SVIP和Admin） -->
      <div v-if="showCardGenerator" class="modal-overlay" @click.self="showCardGenerator = false">
        <div class="modal">
          <div class="modal-header">
            <h3>{{ getCardTypeName() }}生成</h3>
            <button class="close-btn" @click="showCardGenerator = false">×</button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>生成数量</label>
              <div style="display: flex; align-items: center; gap: 10px;">
                <button type="button" class="btn" @click="cardCount = Math.max(1, cardCount - 1)" style="padding: 5px 15px;">-</button>
                <input type="number" v-model="cardCount" min="1" max="1000" style="flex: 1; text-align: center;">
                <button type="button" class="btn" @click="cardCount = Math.min(1000, cardCount + 1)" style="padding: 5px 15px;">+</button>
              </div>
            </div>
            <!-- 机构名称输入框（仅管理员卡显示） -->
            <div class="form-group" v-if="currentCardType === 'admin'">
              <label>机构名称 <span style="color: red;">*</span></label>
              <input type="text" v-model="organizationName" placeholder="请输入机构名称" required>
            </div>
            <!-- 所有卡类型都显示有效期类型选择 -->
            <div class="form-group">
              <label>有效期类型</label>
              <div class="radio-group">
                <div class="radio-row">
                  <label class="radio-item"><input type="radio" v-model="validityType" value="7"> 周卡</label>
                  <label class="radio-item"><input type="radio" v-model="validityType" value="30"> 月卡</label>
                  <label class="radio-item"><input type="radio" v-model="validityType" value="365"> 年卡</label>
                </div>
                <div class="radio-row">
                  <label class="radio-item"><input type="radio" v-model="validityType" value="730"> 2年卡</label>
                  <label class="radio-item"><input type="radio" v-model="validityType" value="1095"> 3年卡</label>
                  <label class="radio-item"><input type="radio" v-model="validityType" value="custom"> 自定义</label>
                </div>
              </div>
            </div>
            <div class="form-group" v-if="validityType === 'custom'">
              <label>自定义天数</label>
              <input type="number" v-model="validDays" min="1">
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn" @click="generateCards">生成</button>
            <button class="btn" @click="showCardGenerator = false">取消</button>
          </div>
        </div>
      </div>
      
      <!-- 会员卡列表弹窗（通用，支持VIP、SVIP和Admin） -->
      <div v-if="showCardList" class="modal-overlay" @click.self="showCardList = false">
        <div class="modal">
          <div class="modal-header">
            <h3>{{ getCardTypeName() }}列表</h3>
            <button class="close-btn" @click="showCardList = false">×</button>
          </div>
          <div class="modal-body">
            <!-- 筛选条件区域 -->
            <div class="filter-section">
              <h4 class="filter-section-title">筛选条件</h4>
              <!-- 卡密和批次号筛选 -->
              <div class="search-filters">
                <div class="filter-group">
                  <label>批次号:</label>
                  <input type="text" v-model="filterBatchNumber" placeholder="输入批次号">
                </div>
                <div class="filter-group">
                  <label>卡密:</label>
                  <input type="text" v-model="filterCardNumber" placeholder="输入卡密">
                </div>
                <!-- 机构名称筛选（仅超级管理员显示） -->
                <div class="filter-group" v-if="isSuperAdmin === '超级管理员'">
                  <label>机构名称:</label>
                  <select v-model="filterOrganizationName">
                    <option value="">全部</option>
                    <option v-for="org in uniqueOrganizations" :key="org" :value="org">{{ org }}</option>
                  </select>
                </div>
                <!-- 添加人筛选 -->
                <div class="filter-group">
                  <label>添加人:</label>
                  <select v-model="filterCreator">
                    <option value="">全部</option>
                    <option v-for="creator in uniqueCreators" :key="creator" :value="creator">{{ creator }}</option>
                  </select>
                </div>
              </div>

              <div class="filter-group">
                <label>状态:</label>
                <select v-model="filterStatus">
                  <option value="">全部</option>
                  <option value="unused">未使用</option>
                  <option value="used">已使用</option>
                </select>
              </div>

              <!-- 有效期筛选 -->
              <div class="filter-group">
                <label>有效期:</label>
                <select v-model="filterValidity">
                  <option value="">全部</option>
                  <option value="7">周卡</option>
                  <option value="30">月卡</option>
                  <option value="365">年卡</option>
                  <option value="730">2年卡</option>
                  <option value="1095">3年卡</option>
                  <option value="custom">自定义</option>
                </select>
              </div>

              <div class="filter-group">
                <label>生成时间:</label>
                <input type="date" v-model="filterStartDate" placeholder="开始日期">
                <span>至</span>
                <input type="date" v-model="filterEndDate" placeholder="结束日期">
              </div>

              <div class="filter-group">
                <label>使用时间:</label>
                <input type="date" v-model="filterUsedStartDate" placeholder="开始日期">
                <span>至</span>
                <input type="date" v-model="filterUsedEndDate" placeholder="结束日期">
              </div>

              <!-- 图片制作筛选 -->
              <div class="filter-group">
                <label>图片制作:</label>
                <select v-model="filterImageMade">
                  <option value="">全部</option>
                  <option value="true">已制作</option>
                  <option value="false">未制作</option>
                </select>
              </div>

              <!-- 自定义天数输入 -->
              <div class="filter-group" v-if="filterValidity === 'custom'">
                <label>自定义天数:</label>
                <input type="number" v-model="filterValidityDays" min="1" placeholder="输入天数">
              </div>

              <div class="filter-actions">
                <button class="btn" @click="resetFilters">重置筛选</button>
                <button class="btn export-btn" @click="exportCardData">导出数据</button>
                <button class="btn image-btn" @click="openCardImageMaker">制作{{ getCardTypeName() }}图片</button>
                <button class="btn close-btn" @click="showCardList = false">关闭</button>
              </div>
            </div>

            <table class="card-table">
              <thead>
                <tr>
                  <th>选择</th>
                  <th>批次号</th>
                  <th>卡密</th>
                  <th v-if="isSuperAdmin === '超级管理员'">机构名称</th>
                  <th>有效期(天)</th>
                  <th>状态</th>
                  <th>添加人</th>
                  <th>生成时间</th>
                  <th>使用时间</th>
                  <th>图片制作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="card in filteredCards" :key="card.id" @click="selectCard(card)" :class="{ selected: selectedCard && selectedCard.id === card.id }">
                  <td><input type="radio" name="selectCard" :checked="selectedCard && selectedCard.id === card.id" @click.stop="selectCard(card)"></td>
                  <td>{{ card.batch_number }}</td>
                  <td>{{ card.card_number }}</td>
                  <td v-if="isSuperAdmin === '超级管理员'">{{ card.organization_name || '-' }}</td>
                  <td>{{ card.valid_days }}</td>
                  <td>{{ card.status === 'unused' ? '未使用' : '已使用' }}</td>
                  <td>{{ card.created_by || '-' }}</td>
                  <td>{{ formatDate(card.created_at) }}</td>
                  <td>{{ card.used_at ? formatDate(card.used_at) : '-' }}</td>
                  <td>{{ card.image_made ? '已制作' : '未制作' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
      </div>
      <!-- 会员卡图片制作弹窗 -->
      <div v-if="showCardImageMaker" class="modal-overlay card-image-modal-overlay" @click="showCardImageMaker = false">
        <div class="modal card-image-modal" @click.stop>
          <div class="modal-header">
            <h3>{{ getCardTypeName() }}图片制作</h3>
            <button class="close-btn" @click="showCardImageMaker = false">×</button>
          </div>
          <div class="modal-body">
            <CardImageMaker
              v-if="selectedCard"
              :batch-number="selectedCard.batch_number"
              :card-number="selectedCard.card_number"
              :valid-days="selectedCard.valid_days"
              :card-type="currentCardType"
              @close="showCardImageMaker = false"
              @image-made-success="updateCardImageStatus"
            />
          </div>
        </div>
      </div>

      <div class="admin-sections">
        <div class="section card-management-buttons">
          <h2>会员卡管理</h2>
          <!-- 超级管理员可以生成和管理所有类型的卡 -->
          <div v-if="isSuperAdmin === '超级管理员'">
            <el-button type="primary" @click="openCardGenerator('vip')">生成会员卡</el-button>
            <el-button type="primary" @click="openCardList('vip')">会员卡列表</el-button>
            <el-button type="success" @click="openCardGenerator('svip')">生成规划师卡</el-button>
            <el-button type="success" @click="openCardList('svip')">规划师卡列表</el-button>
            <el-button type="danger" @click="openCardGenerator('admin')">生成管理员卡</el-button>
            <el-button type="danger" @click="openCardList('admin')">管理员卡列表</el-button>
          </div>
          <!-- 管理员只能生成和管理VIP和SVIP卡 -->
          <div v-else>
            <el-button type="primary" @click="openCardGenerator('vip')">生成会员卡</el-button>
            <el-button type="primary" @click="openCardList('vip')">会员卡列表</el-button>
            <el-button type="success" @click="openCardGenerator('svip')">生成规划师卡</el-button>
            <el-button type="success" @click="openCardList('svip')">规划师卡列表</el-button>
          </div>
        </div>

        <div class="section">
          <h2>用户管理</h2>
          <el-button type="primary" @click="manageUsers">管理用户</el-button>
          <el-button type="warning" @click="managePermissions">权限设置</el-button>
        </div>

        <div class="section">
          <h2>数据管理</h2>
          <el-button type="primary" @click="manageSchools">院校管理</el-button>
          <el-button type="primary" @click="manageMajors">专业管理</el-button>
          <el-button type="primary" @click="manageAdmissionData">招生数据管理</el-button>
        </div>
        
        <div class="section">
          <h2>系统设置</h2>
          <el-button type="primary" @click="systemSettings">系统配置</el-button>
          <el-button type="danger" @click="backupData">数据备份</el-button>
          <el-button type="warning" @click="showFeedbackManager = true">用户反馈管理</el-button>
        </div>
      </div>
    </div>

    <!-- 用户反馈管理弹窗 -->
    <div v-if="showFeedbackManager" class="modal-overlay" @click.self="showFeedbackManager = false">
      <div class="modal" style="width: 90%; max-width: 1000px; max-height: 80vh; overflow-y: auto;">
        <div class="modal-header">
          <h3>用户反馈管理</h3>
          <button class="close-btn" @click="showFeedbackManager = false">×</button>
        </div>
        <div class="modal-body">
          <!-- 状态筛选 -->
          <div class="filter-bar" style="margin-bottom: 15px;">
            <label>状态筛选：</label>
            <select v-model="feedbackStatusFilter" @change="loadFeedbackList" style="padding: 5px; margin-right: 10px;">
              <option value="">全部</option>
              <option value="pending">待处理</option>
              <option value="processing">处理中</option>
              <option value="resolved">已解决</option>
              <option value="closed">已关闭</option>
            </select>
            <button class="btn" @click="loadFeedbackList" style="padding: 5px 15px;">刷新</button>
          </div>
          
          <!-- 反馈列表 -->
          <table class="feedback-table" style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr style="background-color: #f5f5f5;">
                <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">ID</th>
                <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">用户</th>
                <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">所属机构</th>
                <th style="padding: 10px; border: 1px solid #ddd; text-align: left; width: 30%;">反馈内容</th>
                <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">联系方式</th>
                <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">状态</th>
                <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">时间</th>
                <th style="padding: 10px; border: 1px solid #ddd; text-align: left;">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="fb in feedbackList" :key="fb.id" style="border-bottom: 1px solid #eee;">
                <td style="padding: 10px; border: 1px solid #ddd;">{{ fb.id }}</td>
                <td style="padding: 10px; border: 1px solid #ddd;">{{ fb.username }}</td>
                <td style="padding: 10px; border: 1px solid #ddd;">{{ fb.organization_name }}</td>
                <td style="padding: 10px; border: 1px solid #ddd;">{{ fb.content }}</td>
                <td style="padding: 10px; border: 1px solid #ddd;">{{ fb.contact || '-' }}</td>
                <td style="padding: 10px; border: 1px solid #ddd;">
                  <span :class="'status-' + fb.status">{{ fb.status_display }}</span>
                </td>
                <td style="padding: 10px; border: 1px solid #ddd;">{{ fb.created_at }}</td>
                <td style="padding: 10px; border: 1px solid #ddd;">
                  <button class="btn-small" @click="replyFeedback(fb)" style="padding: 3px 8px; margin-right: 5px;">回复</button>
                </td>
              </tr>
              <tr v-if="feedbackList.length === 0">
                <td colspan="8" style="padding: 20px; text-align: center; color: #999;">暂无反馈数据</td>
              </tr>
            </tbody>
          </table>
          
          <!-- 分页 -->
          <div class="pagination" style="margin-top: 15px; text-align: center;">
            <button class="btn" :disabled="feedbackPage <= 1" @click="feedbackPage--; loadFeedbackList()">上一页</button>
            <span style="margin: 0 10px;">第 {{ feedbackPage }} 页</span>
            <button class="btn" @click="feedbackPage++; loadFeedbackList()">下一页</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 回复反馈弹窗 -->
    <div v-if="showReplyModal" class="modal-overlay" @click.self="showReplyModal = false">
      <div class="modal" style="width: 90%; max-width: 1000px; max-height: 90vh; overflow-y: auto;">
        <div class="modal-header">
          <h3>回复反馈</h3>
          <button class="close-btn" @click="showReplyModal = false">×</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>反馈内容</label>
            <div style="padding: 10px; background-color: #f5f5f5; border-radius: 4px; margin-bottom: 15px;">
              {{ currentFeedback.content }}
            </div>
          </div>
          <!-- 反馈图片显示 -->
          <div class="form-group" v-if="currentFeedback.images && currentFeedback.images.length > 0">
            <label>反馈图片</label>
            <div class="feedback-images">
              <div v-for="(img, index) in currentFeedback.images" :key="index" class="feedback-image-item">
                <img :src="getFullImageUrl(img)" alt="反馈图片" @click="previewImage(getFullImageUrl(img))">
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>状态</label>
            <select v-model="replyStatus" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;">
              <option value="pending">待处理</option>
              <option value="processing">处理中</option>
              <option value="resolved">已解决</option>
              <option value="closed">已关闭</option>
            </select>
          </div>
          <div class="form-group">
            <label>回复内容</label>
            <textarea v-model="replyContent" rows="4" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; resize: vertical;" placeholder="请输入回复内容..."></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn" @click="submitReply">提交回复</button>
        </div>
      </div>
    </div>
    
    <!-- 图片预览弹窗 -->
    <div v-if="previewImageUrl" class="modal-overlay" @click.self="previewImageUrl = null" style="z-index: 2000;">
      <div class="modal" style="max-width: 90vw; max-height: 90vh;">
        <div class="modal-header">
          <h3>图片预览</h3>
          <button class="close-btn" @click="previewImageUrl = null">×</button>
        </div>
        <div class="modal-body" style="text-align: center; padding: 20px;">
          <img :src="previewImageUrl" style="max-width: 100%; max-height: 70vh; object-fit: contain;">
        </div>
      </div>
    </div>

    <!-- 消息通知弹窗 -->
    <div v-if="showMessageModal" class="modal-overlay" @click.self="closeMessageModal">
      <div class="message-modal-container">
        <div class="modal-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
          <h3>消息通知</h3>
          <button class="close-btn" @click="closeMessageModal" style="background: none; border: none; font-size: 20px; cursor: pointer;">×</button>
        </div>
        
        <!-- 消息列表 -->
        <div class="message-list" style="max-height: 60vh; overflow-y: auto;">
          <div v-if="messageList.length === 0" class="no-message" style="text-align: center; color: #999; padding: 40px;">
            暂无消息
          </div>
          
          <div v-for="msg in messageList" :key="msg.id" 
               class="message-item" 
               :class="{ unread: !msg.is_read }"
               style="padding: 15px; border-bottom: 1px solid #eee; cursor: pointer;"
               @click="readMessage(msg)">
            <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
              <span style="font-weight: bold; color: #333;">{{ msg.title }}</span>
              <span style="color: #999; font-size: 12px;">{{ msg.created_at }}</span>
            </div>
            <div style="color: #666; font-size: 14px; line-height: 1.5; white-space: pre-wrap;">{{ msg.content }}</div>
            <div v-if="!msg.is_read" style="margin-top: 5px;">
              <span style="color: #f44336; font-size: 12px;">未读</span>
            </div>
          </div>
        </div>
        
        <!-- 操作按钮 -->
        <div class="modal-buttons" style="margin-top: 15px; display: flex; justify-content: space-between;">
          <button type="button" class="btn-cancel" @click="closeMessageModal">关闭</button>
          <button v-if="unreadMessageCount > 0" type="button" class="btn-confirm" @click="markAllMessagesRead">全部已读</button>
        </div>
      </div>
    </div>

    <!-- 问题反馈弹窗 -->
    <div v-if="showFeedbackModal" class="modal-overlay" @click.self="closeFeedbackModal">
      <div class="feedback-modal-container">
        <h3>问题反馈</h3>
        <p class="modal-desc">请描述您遇到的问题或建议，我们会尽快处理</p>
        <div class="feedback-form">
          <div class="feedback-form-item">
            <label class="feedback-label">反馈内容 <span class="required">*</span></label>
            <textarea 
              v-model="feedbackContent" 
              placeholder="请详细描述您遇到的问题..." 
              class="feedback-textarea"
              rows="4"></textarea>
          </div>
          <!-- 图片上传区域 -->
          <div class="feedback-form-item">
            <label class="feedback-label">截图<span class="optional">（选填，支持粘贴图片）</span></label>
            <div class="image-upload-wrapper">
              <div
                class="image-upload-area"
                @paste="handleFeedbackPaste"
                tabindex="0"
                ref="feedbackImageArea"
              >
                <div v-if="feedbackImages.length === 0" class="upload-placeholder">
                  <p>点击此处后按 Ctrl+V 粘贴截图</p>
                  <p style="font-size: 12px; color: #999;">或直接将图片粘贴到此处</p>
                </div>
                <div v-else class="image-preview-list">
                  <div v-for="(img, index) in feedbackImages" :key="index" class="image-preview-item">
                    <img :src="img" alt="反馈图片" @click="previewFeedbackImage(img)">
                    <button type="button" class="remove-image-btn" @click="removeFeedbackImage(index)">×</button>
                  </div>
                  <div v-if="feedbackImages.length < 5" class="add-more-images" @click="focusImageArea">
                    <span>+</span>
                    <p>继续粘贴</p>
                  </div>
                </div>
              </div>
              <input
                type="file"
                ref="feedbackFileInput"
                accept="image/*"
                multiple
                style="display: none;"
                @change="handleFeedbackFileSelect"
              />
              <button type="button" class="upload-image-btn" @click="triggerFeedbackFileInput">
                <span>📁</span>
                <span>上传图片</span>
              </button>
            </div>
            <p v-if="feedbackImages.length > 0" class="image-count-hint">
              已添加 {{ feedbackImages.length }} 张图片，最多5张
            </p>
          </div>
          <div class="feedback-form-item">
            <label class="feedback-label">联系方式<span class="optional">（选填）</span></label>
            <input 
              type="text" 
              v-model="feedbackContact" 
              placeholder="手机号/邮箱/微信，方便我们联系您" 
              class="feedback-input">
          </div>
        </div>
        <div class="feedback-modal-buttons">
          <button type="button" class="feedback-btn-cancel" @click="closeFeedbackModal">取消</button>
          <button type="button" class="feedback-btn-confirm" @click="submitFeedback" :disabled="isSubmittingFeedback">
            {{ isSubmittingFeedback ? '提交中...' : '提交反馈' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import CardImageMaker from './CardImageMaker.vue'; // 添加这行导入语句
// import { getCookie } from '@/utils'

export default {
  name: 'AdminDashboard',
  components: {
    CardImageMaker // 注册CardImageMaker组件
  },
  data() {
    return {
      cards: [], // 会员卡数据 - 必须在data中初始化才是响应式的
      selectedCard: null, // 存储选中的会员卡信息
      userCount: 0,
      actualUserCount: 0,
      userBaseCount: 0,
      schoolCount: 0,
      majorCount: 0,
      lastUpdate: '',
      isLoggedIn: false,
      showUserBaseDialog: false,
      editUserBaseCount: 0,
      username: '',
      userVipInfo: null,
      isSuperAdmin: false,
      showCardGenerator: false,
      showCardList: false,
      showCardImageMaker: false, // 新增：显示会员卡图片查看器
      cardImageUrl: '', // 新增：存储会员卡图片URL
      currentCardType: 'vip', // 当前操作的卡类型：'vip' 或 'svip'
      cardCount: 10,
      cardType: 'vip',
      validDays: 7,
      validityType: '7', // 默认月卡
      organizationName: '', // 机构名称
      validityTypeMap: {
        '7': '周卡',
        '30': '月卡',
        '365': '年卡',
        '730': '2年卡',
        '1095': '3年卡',
        'custom': '自定义天数'
      },
      cardSearch: '',
      // 新增筛选条件
      filterCardNumber: '',
      filterBatchNumber: '',
      filterCardType: '',
      filterStatus: '',
      filterStartDate: '',
      filterEndDate: '',
      filterUsedStartDate: '',
      filterUsedEndDate: '',
      filterImageMade: '',
      // 添加有效期筛选相关数据
      filterValidity: '',
      filterValidityDays: 0,
      // 机构名称筛选
      filterOrganizationName: '',
      // 添加人筛选
      filterCreator: '',
      // 智能轮询相关变量
      loginStatusInterval: null,
      userActivityTimeout: null,
      isUserActive: true,
      lastActivityTime: Date.now(),
      POLLING_INTERVAL_ACTIVE: 30000,
      POLLING_INTERVAL_IDLE: 120000,
      IDLE_TIMEOUT: 120000,
      // 用户反馈管理
      showFeedbackManager: false,
      feedbackList: [],
      feedbackStatusFilter: '',
      feedbackPage: 1,
      feedbackPageSize: 20,
      // 回复反馈
      showReplyModal: false,
      currentFeedback: {},
      replyStatus: '',
      replyContent: '',
      // 图片预览
      previewImageUrl: null,
      // 消息通知
      showMessageModal: false,
      messageList: [],
      unreadMessageCount: 0,
      messagePollingInterval: null,
      // 问题反馈弹窗（普通用户）
      showFeedbackModal: false,
      feedbackContent: '',
      feedbackContact: '',
      isSubmittingFeedback: false,
      feedbackImages: []
    };
  },
  computed: {
    // 通用筛选，根据 currentCardType 自动筛选 VIP、SVIP或Admin 卡
    filteredCards() {
      return this.cards.filter(card => {
        // 根据当前卡类型筛选
        if (card.card_type !== this.currentCardType) {
          return false;
        }

        // 批次号筛选
        const batchNumberMatch = !this.filterBatchNumber ||
          card.batch_number.toLowerCase().includes(this.filterBatchNumber.toLowerCase());
        // 卡密筛选
        const cardNumberMatch = !this.filterCardNumber ||
          card.card_number.toLowerCase().includes(this.filterCardNumber.toLowerCase());

        // 状态筛选
        const statusMatch = !this.filterStatus || card.status === this.filterStatus;

        // 生成时间范围筛选
        const createdDateMatch = (!this.filterStartDate || new Date(card.created_at) >= new Date(this.filterStartDate)) &&
                                 (!this.filterEndDate || new Date(card.created_at) <= new Date(this.filterEndDate + ' 23:59:59'));

        // 使用时间范围筛选
        const usedDateMatch =
          (!this.filterUsedStartDate && !this.filterUsedEndDate) ||
          (!card.used_at && (this.filterUsedStartDate || this.filterUsedEndDate)) ||
          (card.used_at &&
           (!this.filterUsedStartDate || new Date(card.used_at) >= new Date(this.filterUsedStartDate)) &&
           (!this.filterUsedEndDate || new Date(card.used_at) <= new Date(this.filterUsedEndDate + ' 23:59:59')));

        // 图片制作状态筛选
        const imageMadeMatch = !this.filterImageMade ||
          (this.filterImageMade === 'true' && card.image_made) ||
          (this.filterImageMade === 'false' && !card.image_made);

        // 有效期筛选
        let validityMatch = true;
        if (this.filterValidity) {
          if (this.filterValidity === 'custom') {
            validityMatch = card.valid_days === parseInt(this.filterValidityDays);
          } else {
            validityMatch = card.valid_days === parseInt(this.filterValidity);
          }
        }

        // 机构名称筛选（仅超级管理员有效）
        const organizationMatch = !this.filterOrganizationName ||
          card.organization_name === this.filterOrganizationName;

        // 添加人筛选
        const creatorMatch = !this.filterCreator ||
          card.created_by === this.filterCreator;

        return cardNumberMatch && batchNumberMatch && statusMatch && createdDateMatch && usedDateMatch && imageMadeMatch && validityMatch && organizationMatch && creatorMatch;
      });
    },
    // 获取唯一的机构名称列表（根据当前卡类型筛选）
    uniqueOrganizations() {
      const orgs = new Set();
      this.cards.forEach(card => {
        // 只收集当前卡类型的机构名称
        if (card.card_type === this.currentCardType && card.organization_name) {
          orgs.add(card.organization_name);
        }
      });
      return Array.from(orgs).sort();
    },
    // 获取唯一的添加人列表（根据当前卡类型筛选）
    uniqueCreators() {
      const creators = new Set();
      this.cards.forEach(card => {
        // 只收集当前卡类型的添加人
        if (card.card_type === this.currentCardType && card.created_by) {
          creators.add(card.created_by);
        }
      });
      return Array.from(creators).sort();
    }
  },
  mounted() {
    // 检查登录状态
    this.checkLoginStatus().then(() => {
      // 先加载VIP信息，然后判断权限
      this.loadVipInfo().then(() => {
        // 只有管理员才加载数据（包括通过VIP卡激活的管理员）
        const isAdmin = this.isSuperAdmin === '超级管理员' || this.isSuperAdmin === '管理员' ||
                        (this.userVipInfo && this.userVipInfo.is_admin);
        if (isAdmin) {
          // 加载仪表盘数据
          this.loadDashboardData();
          // 加载会员卡数据
          this.loadCardData();
        }
      });
      // 启动消息轮询
      if (this.isLoggedIn) {
        this.startMessagePolling();
      }
    });
    // 启动登录状态轮询
    this.startLoginStatusPolling();
  },
  beforeDestroy() {
    // 组件销毁时停止轮询
    this.stopLoginStatusPolling();
    // 停止消息轮询
    this.stopMessagePolling();
  },
  methods: {
    // 新增：选择会员卡
    selectCard(card) {
      this.selectedCard = card;
    },
    
    // 合并后的 openCardImageMaker 方法
    openCardImageMaker() {
      if (!this.selectedCard) {
        const cardTypeName = this.currentCardType === 'svip' ? '规划师卡' : '会员卡';
        alert(`请先选择一张${cardTypeName}`);
        return;
      }
      this.showCardImageMaker = true;
      // this.loadRecentCardImage();
    },
    
    // 新增：加载最近生成的会员卡图片
    // loadRecentCardImage() {
    //   // 假设后端提供了获取最新会员卡图片的API
    //   axios.get('api/membership-card/latest-image/', {
    //     withCredentials: true
    //   })
    //   .then(response => {
    //     this.cardImageUrl = response.data.image_url;
    //   })
    //   .catch(error => {
    //     console.error('加载会员卡图片失败:', error);
    //     // 如果API调用失败，可以显示默认图片或提示
    //     this.cardImageUrl = '/static/images/default-card.png';
    //   });
    // },
  
    // // 新增：在打开图片查看器时调用
    // openCardImageMaker() {
    //   this.showCardImageMaker = true;
    //   this.loadRecentCardImage();
    // },
    checkLoginStatus() {
      // const csrftoken = getCookie('csrftoken');

      return axios.get('api/check-login/', {
        // withCredentials: true,
        // headers: { 'X-Csrftoken': csrftoken },
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
        // credentials: 'include'  // 确保发送cookie
      })
      .then(response => {
        // 检查是否被踢出（异地登录）
        if (response.data.isKickedOut) {
          const deviceType = response.data.kickedOutInfo?.device_type || '其他设备';
          const kickedTime = response.data.kickedOutInfo?.kicked_at || '';
          this.$message.warning(
            `您的账号已在${deviceType}上登录，您已被踢出。\n登录时间：${kickedTime}`,
            5000
          );
          this.handleKickedOut();
          return response;
        }
        this.isLoggedIn = response.data.isLoggedIn;
        this.username = response.data.displayName || response.data.username;
        this.isSuperAdmin = response.data.isSuperAdmin;
        return response;
      })
      .catch(error => {
        console.error('检查登录状态失败:', error);
        this.isLoggedIn = false;
        this.username = '';
        this.isSuperAdmin = '用户';
        throw error;
      });
    },

    // 处理被踢出
    handleKickedOut() {
      // 清除本地登录状态
      this.isLoggedIn = false;
      this.username = '';
      this.isSuperAdmin = '用户';
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('username');
      localStorage.removeItem('isSuperAdmin');

      // 停止登录状态轮询
      if (this.loginStatusInterval) {
        clearTimeout(this.loginStatusInterval);
        this.loginStatusInterval = null;
      }

      // 调用后端登出
      axios.post('api/logout/', {}, {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      }).finally(() => {
        // 跳转到登录页
        this.$router.push('/login');
      });
    },

    // 启动登录状态轮询（智能轮询）
    startLoginStatusPolling() {
      this.stopLoginStatusPolling();
      this.startUserActivityMonitoring();
      this.scheduleNextPoll();
    },

    // 调度下一次轮询
    scheduleNextPoll() {
      if (this.loginStatusInterval) {
        clearTimeout(this.loginStatusInterval);
        this.loginStatusInterval = null;
      }
      const interval = this.isUserActive ? this.POLLING_INTERVAL_ACTIVE : this.POLLING_INTERVAL_IDLE;
      this.loginStatusInterval = setTimeout(() => {
        if (this.isLoggedIn) {
          this.checkLoginStatus().catch(error => {
            if (error.message === 'KICKED_OUT') {
              // 被踢出已在checkLoginStatus中处理
            }
          }).finally(() => {
            this.scheduleNextPoll();
          });
        }
      }, interval);
    },

    // 停止登录状态轮询
    stopLoginStatusPolling() {
      if (this.loginStatusInterval) {
        clearTimeout(this.loginStatusInterval);
        this.loginStatusInterval = null;
      }
      this.stopUserActivityMonitoring();
    },

    // 启动用户活动监听
    startUserActivityMonitoring() {
      this.lastActivityTime = Date.now();
      this.isUserActive = true;
      const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
      this.handleUserActivity = () => {
        const wasIdle = !this.isUserActive;
        this.lastActivityTime = Date.now();
        this.isUserActive = true;
        if (wasIdle) {
          this.scheduleNextPoll();
        }
        this.resetIdleTimeout();
      };
      activityEvents.forEach(event => {
        document.addEventListener(event, this.handleUserActivity, true);
      });
      this.resetIdleTimeout();
    },

    // 停止用户活动监听
    stopUserActivityMonitoring() {
      if (this.handleUserActivity) {
        const activityEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
        activityEvents.forEach(event => {
          document.removeEventListener(event, this.handleUserActivity, true);
        });
        this.handleUserActivity = null;
      }
      if (this.userActivityTimeout) {
        clearTimeout(this.userActivityTimeout);
        this.userActivityTimeout = null;
      }
    },

    // 重置空闲检测定时器
    resetIdleTimeout() {
      if (this.userActivityTimeout) {
        clearTimeout(this.userActivityTimeout);
      }
      this.userActivityTimeout = setTimeout(() => {
        const idleTime = Date.now() - this.lastActivityTime;
        if (idleTime >= this.IDLE_TIMEOUT) {
          this.isUserActive = false;
          this.scheduleNextPoll();
        }
      }, this.IDLE_TIMEOUT);
    },

    // 加载用户VIP信息
    loadVipInfo() {
      return axios.get('api/vip-info/', {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
        .then(response => {
          this.userVipInfo = response.data;
        })
        .catch(error => {
          console.error('加载VIP信息失败:', error);
          this.userVipInfo = null;
        });
    },

    loadDashboardData() {
      // 从后端API获取仪表盘数据
      // const csrftoken = getCookie('csrftoken');
      
      axios.get('api/admin/dashboard/', {
        // withCredentials: true,
        // headers: { 'X-Csrftoken': csrftoken }
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
      .then(response => {
        this.userCount = response.data.user_count;
        this.actualUserCount = response.data.actual_user_count || 0;
        this.userBaseCount = response.data.user_base_count || 0;
        this.schoolCount = response.data.school_count;
        this.majorCount = response.data.major_count;
        this.lastUpdate = response.data.last_update;
      })
      .catch(error => {
        console.error('加载仪表盘数据失败:', error);
        // 加载失败时使用默认数据
        this.userCount = 0;
        this.schoolCount = 0;
        this.majorCount = 0;
        this.lastUpdate = '暂无数据';
      });
    },
    
    loadCardData() {
      axios.get('api/admin/cards/', {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
      .then(response => {
        this.cards = response.data.cards || [];
      })
      .catch(error => {
        console.error('加载会员卡数据失败:', error);
        this.cards = [];
      });
    },
    // 重置筛选方法
    resetFilters() {
      this.filterCardNumber = '';
      this.filterBatchNumber = '';
      this.filterStatus = '';
      this.filterStartDate = '';
      this.filterEndDate = '';
      this.filterUsedStartDate = '';
      this.filterUsedEndDate = '';
      this.filterValidity = '';
      this.filterValidityDays = 0;
      this.filterImageMade = '';
      this.filterOrganizationName = '';
      this.filterCreator = '';
      this.cardSearch = '';
    },
    // 打开用户基数设置弹窗
    openUserBaseDialog() {
      this.editUserBaseCount = this.userBaseCount;
      this.showUserBaseDialog = true;
    },
    // 保存用户基数
    saveUserBaseCount() {
      axios.post('api/admin/set-user-base-count/', {
        user_base_count: parseInt(this.editUserBaseCount) || 0
      }, {
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-Csrftoken',
      })
      .then(response => {
        if (response.data.success) {
          this.$message.success('用户基数设置成功');
          this.userBaseCount = parseInt(this.editUserBaseCount) || 0;
          this.userCount = this.actualUserCount + this.userBaseCount;
          this.showUserBaseDialog = false;
        } else {
          this.$message.error(response.data.message || '设置失败');
        }
      })
      .catch(error => {
        console.error('设置用户基数失败:', error);
        this.$message.error('设置用户基数失败');
      });
    },
    // 更新会员卡图片制作状态
    updateCardImageStatus(cardNumber) {
      console.log('updateCardImageStatus 被调用，卡号:', cardNumber);
      // 在本地数据中更新该卡的图片制作状态
      const cardIndex = this.cards.findIndex(c => c.card_number === cardNumber);
      if (cardIndex !== -1) {
        // 使用 $set 确保响应式更新
        this.$set(this.cards, cardIndex, {
          ...this.cards[cardIndex],
          image_made: true
        });
        this.$message.success(`会员卡 ${cardNumber} 的图片制作状态已更新为：已制作`);
        console.log('本地数据已更新，cards[' + cardIndex + '].image_made:', this.cards[cardIndex].image_made);
      } else {
        console.log('本地未找到该卡，从服务器重新加载');
        // 如果本地找不到，重新加载数据
        this.loadCardData();
      }
    },
    // 导出会员卡数据
    exportCardData() {
      // 根据是否是超级管理员决定表头
      const headers = this.isSuperAdmin === '超级管理员'
        ? "批次号,卡密,机构名称,有效期(天),状态,添加人,生成时间,使用时间,图片制作\n"
        : "批次号,卡密,有效期(天),状态,添加人,生成时间,使用时间,图片制作\n";

      const csvContent = headers +
        this.filteredCards.map(card => {
          const data = [
            card.batch_number,
            card.card_number,
            ...(this.isSuperAdmin === '超级管理员' ? [card.organization_name || '-'] : []),
            card.valid_days,
            card.status === 'unused' ? '未使用' : '已使用',
            card.created_by || '-',
            card.created_at ? this.formatDate(card.created_at) : '-',
            card.used_at ? this.formatDate(card.used_at) : '-',
            card.image_made ? '已制作' : '未制作'
          ];

          return data.join(',');
        }).join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);

      const typeName = this.getCardTypeName();
      const fileName = `${typeName}数据_${new Date().toISOString().slice(0,10)}.csv`;
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 打开生成弹窗
    openCardGenerator(type) {
      this.currentCardType = type;
      // 会员卡和规划师卡默认都生成1张
      this.cardCount = 1;
      this.validityType = '365';
      this.validDays = 365;
      this.showCardGenerator = true;
    },
    
    // 打开列表弹窗
    openCardList(type) {
      this.currentCardType = type;
      this.resetFilters();
      this.showCardList = true;
    },
    
    generateCards() {
      // 生成管理员卡时，必须提供机构名称
      if (this.currentCardType === 'admin' && !this.organizationName.trim()) {
        alert('请输入机构名称！');
        return;
      }

      // 计算实际有效期天数
      let validDays;

      if (this.currentCardType === 'svip') {
        // SVIP卡直接使用 validDays
        validDays = parseInt(this.validDays);
      } else {
        // VIP卡和Admin卡根据 validityType 计算
        validDays = this.validityType === 'custom' ? parseInt(this.validDays) : parseInt(this.validityType);
      }

      const requestData = {
        quantity: parseInt(this.cardCount),
        valid_days: validDays,
        card_type: this.currentCardType,
        organization_name: this.organizationName.trim() || undefined
      };

      // 批量生成会员卡
      axios.post('api/generate-cards/', requestData)
      .then(response => {
        const typeName = this.getCardTypeName();
        const orgInfo = response.data.organization_name ? `（机构：${response.data.organization_name}）` : '';
        alert(`成功生成${response.data.count}张${typeName}${orgInfo}`);
        this.showCardGenerator = false;
        this.organizationName = ''; // 清空机构名称
        this.loadCardData();
      })
      .catch(error => {
        console.error('生成会员卡失败:', error);
        alert('生成失败，请重试');
      });
    },

    // 获取卡类型中文名称
    getCardTypeName() {
      const typeMap = {
        'vip': '会员卡',
        'svip': '规划师卡',
        'admin': '管理员卡'
      };
      return typeMap[this.currentCardType] || '会员卡';
    },
    
    // getCookie(name) {
    //   let cookieValue = null;
    //   if (document.cookie && document.cookie !== '') {
    //     const cookies = document.cookie.split(';');
    //     for (let i = 0; i < cookies.length; i++) {
    //       const cookie = cookies[i].trim();
    //       if (cookie.substring(0, name.length + 1) === (name + '=')) {
    //         cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
    //         break;
    //       }
    //     }
    //   }
    //   return cookieValue;
    // },
    
    logout() {
      // 调用后端API进行登出
      axios.post('api/logout/')
      .then(() => {
        // 退出成功后，更新本地状态
        this.isLoggedIn = false;
        this.isSuperAdmin = '用户';
        this.username = '';
            // 可选：清除本地存储的其他认证相关信息
        localStorage.removeItem('csrftoken');
        localStorage.removeItem('user');
        // 退出登录后跳转到首页
        this.$router.push('/');
      })
      .catch(error => {
        console.error('退出登录失败:', error);
        // 即使API调用失败，也清除本地状态
        this.isLoggedIn = false;
        this.username = '';
        this.isSuperAdmin = '用户';
        localStorage.removeItem('csrftoken');
        localStorage.removeItem('user');
      });
    },
    
    // 管理员功能方法
    manageUsers() {
      alert('用户管理功能开发中...');
    },
    
    managePermissions() {
      alert('权限设置功能开发中...');
    },
    
    manageSchools() {
      alert('院校管理功能开发中...');
    },
    
    manageMajors() {
      alert('专业管理功能开发中...');
    },
    
    manageAdmissionData() {
      alert('招生数据管理功能开发中...');
    },
    
    systemSettings() {
      alert('系统配置功能开发中...');
    },
    
    backupData() {
      alert('数据备份功能开发中...');
    },

    // 用户反馈管理方法
    async loadFeedbackList() {
      try {
        const response = await axios.get('api/feedback/list/', {
          params: {
            status: this.feedbackStatusFilter,
            page: this.feedbackPage,
            page_size: this.feedbackPageSize
          },
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        if (response.data.success) {
          this.feedbackList = response.data.data;
        } else {
          this.$message.error(response.data.error || '加载失败');
        }
      } catch (err) {
        console.error('加载反馈列表失败:', err);
        this.$message.error('加载反馈列表失败');
      }
    },

    replyFeedback(feedback) {
      this.currentFeedback = feedback;
      this.replyStatus = feedback.status;
      this.replyContent = feedback.reply || '';
      this.showReplyModal = true;
    },

    async submitReply() {
      try {
        const response = await axios.post(`api/feedback/${this.currentFeedback.id}/update/`, {
          status: this.replyStatus,
          reply: this.replyContent
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken',
        });
        
        if (response.data.success) {
          this.$message.success('回复提交成功');
          this.showReplyModal = false;
          this.loadFeedbackList(); // 刷新列表
        } else {
          this.$message.error(response.data.error || '提交失败');
        }
      } catch (err) {
        console.error('提交回复失败:', err);
        this.$message.error('提交回复失败');
      }
    },

    // 获取完整图片URL
    getFullImageUrl(url) {
      if (!url) return '';
      // 如果已经是完整URL，直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 如果是相对路径，添加后端服务地址
      if (url.startsWith('/')) {
        // 开发环境使用 localhost:8000，生产环境使用当前域名
        const isDev = window.location.port === '8080';
        if (isDev) {
          return 'http://localhost:8000' + url;
        }
        return window.location.origin + url;
      }
      return url;
    },

    // 预览图片
    previewImage(url) {
      this.previewImageUrl = url;
    },

    // 新增缺失的方法
    goToLogin() {
      this.$router.push('/login');
    },
    
    goToRegister() {
      this.$router.push('/register');
    },
    
    goToSearch() {
      this.$router.push('/');
    },
    
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleString('zh-CN');
    },

    // ========== 消息通知相关方法 ==========
    
    // 获取用户消息列表
    async loadMessages() {
      if (!this.isLoggedIn) return;
      
      try {
        const response = await axios.get('api/messages/', {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.messageList = response.data.data;
          this.unreadMessageCount = response.data.unread_count;
        }
      } catch (err) {
        console.error('获取消息失败:', err);
      }
    },
    
    // 关闭消息弹窗
    closeMessageModal() {
      this.showMessageModal = false;
    },
    
    // 阅读消息
    async readMessage(msg) {
      if (!msg.is_read) {
        try {
          await axios.post(`api/messages/${msg.id}/read/`, {}, {
            withCredentials: true
          });
          msg.is_read = true;
          this.unreadMessageCount = Math.max(0, this.unreadMessageCount - 1);
        } catch (err) {
          console.error('标记已读失败:', err);
        }
      }
    },
    
    // 标记所有消息为已读
    async markAllMessagesRead() {
      try {
        await axios.post('api/messages/read-all/', {}, {
          withCredentials: true
        });
        
        // 更新本地状态
        this.messageList.forEach(msg => {
          msg.is_read = true;
        });
        this.unreadMessageCount = 0;
        
        this.$message.success('所有消息已标记为已读');
      } catch (err) {
        console.error('标记全部已读失败:', err);
        this.$message.error('操作失败');
      }
    },
    
    // 启动消息轮询
    startMessagePolling() {
      // 如果已经在轮询中，先停止之前的
      if (this.messagePollingInterval) {
        this.stopMessagePolling();
      }
      
      // 立即加载一次
      this.loadMessages();
      
      // 每30秒轮询一次
      this.messagePollingInterval = setInterval(() => {
        this.loadMessages();
      }, 30000);
    },
    
    // 停止消息轮询
    stopMessagePolling() {
      if (this.messagePollingInterval) {
        clearInterval(this.messagePollingInterval);
        this.messagePollingInterval = null;
      }
    },

    // ========== 问题反馈相关方法 ==========
    
    // 关闭反馈弹窗
    closeFeedbackModal() {
      this.showFeedbackModal = false;
      this.feedbackContent = '';
      this.feedbackContact = '';
      this.feedbackImages = [];
    },
    
    // 提交问题反馈
    async submitFeedback() {
      if (!this.feedbackContent.trim()) {
        this.$message.error('请输入反馈内容');
        return;
      }
      
      this.isSubmittingFeedback = true;
      
      try {
        const response = await axios.post('api/feedback/', {
          content: this.feedbackContent,
          contact: this.feedbackContact,
          images: this.feedbackImages
        }, {
          withCredentials: true
        });
        
        if (response.data.success) {
          this.$message.success('反馈提交成功，我们会尽快处理');
          this.closeFeedbackModal();
        } else {
          this.$message.error(response.data.error || '提交失败');
        }
      } catch (err) {
        console.error('提交反馈失败:', err);
        this.$message.error('提交失败，请稍后重试');
      } finally {
        this.isSubmittingFeedback = false;
      }
    },
    
    // 处理反馈图片粘贴
    handleFeedbackPaste(e) {
      const items = e.clipboardData.items;
      
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const blob = items[i].getAsFile();
          const reader = new FileReader();
          
          reader.onload = (event) => {
            if (this.feedbackImages.length < 5) {
              this.feedbackImages.push(event.target.result);
            } else {
              this.$message.warning('最多只能添加5张图片');
            }
          };
          
          reader.readAsDataURL(blob);
        }
      }
    },
    
    // 移除反馈图片
    removeFeedbackImage(index) {
      this.feedbackImages.splice(index, 1);
    },
    
    // 聚焦图片区域
    focusImageArea() {
      this.$refs.feedbackImageArea?.focus();
      this.$message.info('请按 Ctrl+V 粘贴图片');
    },

    // 触发文件选择
    triggerFeedbackFileInput() {
      if (this.feedbackImages.length >= 5) {
        this.$message.warning('最多只能添加5张图片');
        return;
      }
      this.$refs.feedbackFileInput?.click();
    },

    // 处理文件选择
    handleFeedbackFileSelect(e) {
      const files = e.target.files;
      if (!files || files.length === 0) return;

      const remainingSlots = 5 - this.feedbackImages.length;
      const filesToProcess = Math.min(files.length, remainingSlots);

      if (files.length > remainingSlots) {
        this.$message.warning(`最多还能添加${remainingSlots}张图片`);
      }

      for (let i = 0; i < filesToProcess; i++) {
        const file = files[i];
        if (!file.type.startsWith('image/')) {
          this.$message.warning(`${file.name} 不是图片文件，已跳过`);
          continue;
        }

        const reader = new FileReader();
        reader.onload = (event) => {
          this.feedbackImages.push(event.target.result);
        };
        reader.readAsDataURL(file);
      }

      // 清空input，允许重复选择同一文件
      e.target.value = '';
    },

    // 预览反馈图片
    previewFeedbackImage(url) {
      this.previewImageUrl = url;
    },

  },
  watch: {
    // 当 showCardList 变为 true 时，重新加载会员卡数据
    showCardList(newVal) {
      if (newVal) {
        this.loadCardData();
      }
    },
    // 当图片制作弹窗关闭时，重新加载会员卡数据
    showCardImageMaker(newVal) {
      console.log('showCardImageMaker 变化:', newVal);
      if (!newVal) {
        // 弹窗关闭时重新加载数据
        this.loadCardData();
        // 使用 $nextTick 确保视图更新
        this.$nextTick(() => {
          this.$forceUpdate();
          console.log('视图已强制更新');
        });
      }
    },
    // 当反馈管理弹窗打开时，加载反馈数据
    showFeedbackManager(newVal) {
      if (newVal) {
        this.feedbackPage = 1;
        this.loadFeedbackList();
      }
    }
  }
};
</script>

<style scoped>
.admin-dashboard {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f5;
}

/* 调整样式以匹配 Dashboard */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #4a67fb;
  color: white;
}

.auth-btn {
  padding: 5px 15px;
  background-color: #0482ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.auth-btn:hover {
  background-color: #66b1ff;
}

/* 消息按钮样式和悬停效果 */
.admin-dashboard .message-feedback-group .auth-btn.message-btn {
  position: relative;
  transition: background-color 0.3s ease;
}

.admin-dashboard .message-feedback-group .auth-btn.message-btn:hover {
  background-color: #42A5F5 !important;
}

/* 问题反馈按钮样式和悬停效果 */
.admin-dashboard .message-feedback-group .auth-btn.feedback-btn {
  transition: background-color 0.3s ease;
}

.admin-dashboard .message-feedback-group .auth-btn.feedback-btn:hover {
  background-color: #ffb74d !important;
}

.username {
  background-color: #ff6b35;
}

.username:hover {
  background-color: #ff8c61;
}

.dashboard-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.dashboard-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.card-header h3 {
  margin: 0 0 10px 0;
  color: #333;
}

.card-content {
  text-align: center;
}

.card-value {
  font-size: 32px;
  font-weight: bold;
  color: #4a67fb;
  margin-bottom: 5px;
}

.card-description {
  color: #666;
  font-size: 14px;
}

.admin-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
}

.section h2 {
  margin: 0 0 20px 0;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.section .el-button {
  margin-right: 10px;
  margin-bottom: 10px;
}

/* 卡管理按钮区域 - 小屏两列两行，上下对齐 */
.card-management-buttons {
  display: flex;
  flex-direction: column;
}

.card-management-buttons h2 {
  width: 100%;
  margin-bottom: 15px;
}

.card-management-buttons > div {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.card-management-buttons .el-button {
  margin: 0 !important;
  min-height: 40px;
  width: 100%;
}

/* 大屏时恢复为单行 */
@media (min-width: 768px) {
  .card-management-buttons > div {
    display: flex;
    flex-wrap: wrap;
  }
  .card-management-buttons .el-button {
    margin-right: 10px !important;
    margin-bottom: 10px !important;
    width: auto;
  }
}

/* 新增样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
}

.card-image-modal {
  width: 800px; /* 根据需要调整宽度 */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.modal-footer {
  padding: 15px;
  border-top: 1px solid #eee;
  text-align: right;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.radio-row {
  display: flex;
  justify-content: center; /* 修改为居中对齐 */
  gap: 30px; /* 使用固定间隙 */
}

.radio-item {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  cursor: pointer;
}

.radio-item input[type="radio"] {
  transform: scale(1.2);
  margin: 0;
  width: auto;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.card-table {
  width: 100%;
  border-collapse: collapse;
}

.card-table th,
.card-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.card-table th {
  background-color: #f5f5f5;
}

.search-box {
  margin-bottom: 15px;
}

.search-box input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}


.admin-btn {
  padding: 10px 20px;
  background-color: #4a67fb; 
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.admin-btn:hover {
  background-color: #3a56e8; 
}

/* 筛选区域样式 */
.filter-section {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin: 15px 0;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.filter-section-title {
  width: 100%;
  margin: 0 0 10px 0;
  padding-bottom: 8px;
  font-size: 16px;
  font-weight: bold;
  color: #4a67fb;
  text-align: center;
  border-bottom: 2px solid #4a67fb;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 5px;
}

.filter-group label {
  font-weight: bold;
  color: #333;
  min-width: 80px;
}

.filter-group select,
.filter-group input[type="date"] {
  padding: 5px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.filter-actions {
  margin-left: auto;
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-actions .btn {
  padding: 6px 15px;
  background-color: #909399;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.filter-actions .btn:hover {
  background-color: #a6a9ad;
}

/* 导出数据按钮 */
.filter-actions .btn.export-btn {
  background-color: #4CAF50; /* 绿色 */
  color: white;
}

.filter-actions .btn.export-btn:hover {
  background-color: #45a049;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}

/* 制作会员卡图片按钮 */
.filter-actions .btn.image-btn {
  background-color: #2196F3; /* 蓝色 */
  color: white;
}

.filter-actions .btn.image-btn:hover {
  background-color: #0b7dda;
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
}

/* 关闭按钮 */
.filter-actions .btn.close-btn {
  background-color: #f44336; /* 红色 */
  color: white;
}

.filter-actions .btn.close-btn:hover {
  background-color: #da190b;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.3);
}

/* 卡密和批次号筛选区域样式 */
.search-filters {
  display: flex;
  gap: 15px;
  margin: 15px 0;
}

.search-filters .filter-group {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 5px;
}

.search-filters .filter-group label {
  font-weight: bold;
  color: #333;
  min-width: 60px;
}

.search-filters .filter-group input {
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* 确保会员卡图片制作弹窗显示在最上层 */
.card-image-modal-overlay {
  z-index: 1100; /* 比普通弹窗更高的层级 */
}
/* 会员卡表格样式 */
.card-table tbody tr {
  cursor: pointer;
}

.card-table tbody tr.selected {
  background-color: #e6f7ff;
}

.card-table tbody tr:hover {
  background-color: #f5f5f5;
}

/* 响应式设计：小屏设备优化 */
@media screen and (max-width: 768px) {
  /* 模态框适配小屏 */
  .modal {
    width: 95% !important;
    max-width: 95% !important;
    margin: 10px;
    max-height: 95vh;
    overflow-y: auto;
  }

  /* 会员卡列表表格容器 - 不滚动，自适应屏幕 */
  .modal-body {
    overflow-x: visible;
    overflow-y: auto;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
  }

  /* 表格样式调整 - 自适应屏幕宽度 */
  .card-table {
    width: 100% !important;
    min-width: 100%;
    font-size: 10px;
    table-layout: fixed;
    border-collapse: collapse;
  }

  .card-table th,
  .card-table td {
    padding: 5px 3px;
    text-align: left;
    word-wrap: break-word;
    word-break: break-all;
    overflow-wrap: break-word;
    white-space: normal;
    vertical-align: top;
  }

  /* 各列宽度分配 - 使用百分比自适应屏幕 */
  /* 普通管理员：9列（选择、批次号、卡密、有效期、状态、添加人、生成时间、使用时间、图片制作） */
  /* 超级管理员：10列（选择、批次号、卡密、机构名称、有效期、状态、添加人、生成时间、使用时间、图片制作） */
  
  /* 统一表头和内容文字大小 */
  .card-table th,
  .card-table td {
    font-size: 10px;
    text-align: center;
    vertical-align: middle !important;
  }

  .card-table th:nth-child(1),
  .card-table td:nth-child(1) { /* 选择列 */
    width: 8%;
    text-align: center;
  }

  .card-table th:nth-child(2),
  .card-table td:nth-child(2) { /* 批次号 */
    width: 16%;
    text-align: center;
  }

  .card-table th:nth-child(3),
  .card-table td:nth-child(3) { /* 卡密 */
    width: 18%;
    text-align: center;
  }

  /* 超级管理员的机构名称列（第4列） */
  .card-table th:nth-child(4),
  .card-table td:nth-child(4) { /* 机构名称 */
    width: 10%;
    text-align: center;
  }

  .card-table th:nth-child(5),
  .card-table td:nth-child(5) { /* 有效期 */
    width: 8%;
    text-align: center;
  }

  .card-table th:nth-child(6),
  .card-table td:nth-child(6) { /* 状态 */
    width: 8%;
    text-align: center;
  }

  .card-table th:nth-child(7),
  .card-table td:nth-child(7) { /* 添加人 */
    width: 8%;
    text-align: center;
  }

  .card-table th:nth-child(8),
  .card-table td:nth-child(8) { /* 生成时间 */
    width: 10%;
    text-align: center;
  }

  .card-table th:nth-child(9),
  .card-table td:nth-child(9) { /* 使用时间 */
    width: 10%;
    text-align: center;
  }

  .card-table th:nth-child(10),
  .card-table td:nth-child(10) { /* 图片制作 */
    width: 8%;
    text-align: center;
  }

  /* 筛选条件区域垂直排列 */
  .filter-section {
    flex-direction: column;
    gap: 10px;
  }

  .filter-section-title {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .filter-group {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
  }

  .filter-group label {
    margin-bottom: 5px;
    font-size: 12px;
    min-width: auto;
  }

  .filter-group input,
  .filter-group select {
    width: 100%;
    padding: 6px;
    box-sizing: border-box;
  }

  /* 按钮区域换行显示 */
  .filter-actions {
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
  }

  .filter-actions .btn {
    padding: 8px 12px;
    font-size: 12px;
  }

  /* 单选框缩小 */
  .card-table input[type="radio"] {
    transform: scale(0.8);
  }

  /* 卡密和批次号筛选区域 */
  .search-filters {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }

  .search-filters .filter-group {
    width: 100%;
  }
}

/* 超小屏设备进一步优化 */
@media screen and (max-width: 480px) {
  .modal-body {
    padding: 5px;
  }

  .card-table {
    font-size: 9px;
    table-layout: fixed;
  }

  .card-table th,
  .card-table td {
    padding: 3px 2px;
    word-wrap: break-word;
    word-break: break-all;
    overflow-wrap: break-word;
    white-space: normal;
    vertical-align: top;
  }

  /* 确保表头和内容文字大小一致 */
  .card-table th,
  .card-table td {
    font-size: 10px !important;
  }

  /* 进一步调整列宽 - 9列表格，卡密列更小 */
  .card-table th:nth-child(1),
  .card-table td:nth-child(1) { /* 选择 */
    width: 20px;
    min-width: 20px;
  }

  .card-table th:nth-child(2),
  .card-table td:nth-child(2) { /* 批次号 */
    width: 40px;
    min-width: 40px;
    font-size: 9px;
  }

  .card-table th:nth-child(3),
  .card-table td:nth-child(3) { /* 卡密 - 进一步减小 */
    width: 55px;
    min-width: 55px;
    max-width: 70px;
    font-size: 8px;
  }

  /* 机构名称列（如果是超级管理员） */
  .card-table th:nth-child(4),
  .card-table td:nth-child(4) {
    width: 45px;
    min-width: 45px;
    font-size: 9px;
  }

  /* 有效期列 */
  .card-table th:nth-child(5),
  .card-table td:nth-child(5) {
    width: 30px;
    min-width: 30px;
    font-size: 9px;
  }

  /* 状态列 */
  .card-table th:nth-child(6),
  .card-table td:nth-child(6) {
    width: 30px;
    min-width: 30px;
    font-size: 9px;
  }

  /* 日期列字体更小 */
  .card-table th:nth-child(7),
  .card-table td:nth-child(7), /* 生成时间 */
  .card-table th:nth-child(8),
  .card-table td:nth-child(8) { /* 使用时间 */
    width: 45px;
    min-width: 45px;
    font-size: 7px;
  }

  /* 图片制作列 */
  .card-table th:nth-child(9),
  .card-table td:nth-child(9) {
    width: 30px;
    min-width: 30px;
    font-size: 9px;
  }

  /* 超小屏下不隐藏列，所有列都缩小显示 */
}

/* 小屏设备优化 - 标题单独一行 */
@media (max-width: 768px) {
  .admin-dashboard .page-header {
    flex-direction: column !important;
    align-items: center !important;
    gap: 10px !important;
  }

  .admin-dashboard .page-header h1 {
    width: 100% !important;
    font-size: 18px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    text-align: center !important;
  }

  /* 按钮容器 - 三列两行布局 */
  .admin-dashboard .page-header > div {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    grid-template-rows: repeat(2, 1fr) !important;
    gap: 8px !important;
    width: 100% !important;
    justify-items: stretch !important;
    align-items: stretch !important;
  }

  /* 志愿查询按钮在第一列跨两行 */
  .admin-dashboard .page-header > div > button:first-child {
    grid-column: 1 / 2 !important;
    grid-row: 1 / 3 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
  }

  /* 消息按钮在第一行第二列 */
  .admin-dashboard .message-feedback-group .message-btn {
    grid-column: 2 / 3 !important;
    grid-row: 1 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 6px 10px !important;
  }

  /* 问题反馈按钮在第二行第二列 */
  .admin-dashboard .message-feedback-group .feedback-btn {
    grid-column: 2 / 3 !important;
    grid-row: 2 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 6px 10px !important;
  }

  /* 消息反馈组重置为contents以允许子元素独立定位 */
  .admin-dashboard .message-feedback-group {
    display: contents !important;
  }

  /* 用户名/登录按钮在第一行第三列 */
  .admin-dashboard .page-header > div > div:nth-of-type(2) .auth-btn:first-child,
  .admin-dashboard .page-header > div > div:nth-of-type(3) .auth-btn:first-child {
    grid-column: 3 / 4 !important;
    grid-row: 1 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 6px 10px !important;
  }

  /* 退出/注册按钮在第二行第三列 */
  .admin-dashboard .page-header > div > div:nth-of-type(2) .auth-btn:last-child,
  .admin-dashboard .page-header > div > div:nth-of-type(3) .auth-btn:last-child {
    grid-column: 3 / 4 !important;
    grid-row: 2 !important;
    height: 100% !important;
    min-height: 48px !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 6px 10px !important;
  }

  /* 登录注册组重置为contents */
  .admin-dashboard .page-header > div > div:nth-of-type(2),
  .admin-dashboard .page-header > div > div:nth-of-type(3) {
    display: contents !important;
  }

  /* 消息按钮悬停效果 */
  .admin-dashboard .message-feedback-group .message-btn:hover {
    background-color: #42A5F5 !important;
  }

  /* 问题反馈按钮悬停效果 */
  .admin-dashboard .message-feedback-group .feedback-btn:hover {
    background-color: #ffb74d !important;
  }
}

/* 极小屏设备优化 */
@media screen and (max-width: 360px) {
  .card-table {
    font-size: 8px;
    table-layout: fixed;
  }

  .card-table th,
  .card-table td {
    padding: 2px 1px;
    word-wrap: break-word;
    word-break: break-all;
    overflow-wrap: break-word;
    white-space: normal;
    vertical-align: top;
  }

  /* 确保表头和内容文字大小一致 */
  .card-table th,
  .card-table td {
    font-size: 10px !important;
  }

  /* 选择列 */
  .card-table th:nth-child(1),
  .card-table td:nth-child(1) {
    width: 18px;
    min-width: 18px;
  }

  /* 批次号 */
  .card-table th:nth-child(2),
  .card-table td:nth-child(2) {
    width: 35px;
    min-width: 35px;
    font-size: 8px;
  }

  /* 卡密列 - 进一步减小 */
  .card-table th:nth-child(3),
  .card-table td:nth-child(3) {
    width: 45px;
    min-width: 45px;
    max-width: 55px;
    font-size: 7px;
  }

  /* 机构名称列 */
  .card-table th:nth-child(4),
  .card-table td:nth-child(4) {
    width: 35px;
    min-width: 35px;
    font-size: 8px;
  }

  /* 有效期 */
  .card-table th:nth-child(5),
  .card-table td:nth-child(5) {
    width: 28px;
    min-width: 28px;
    font-size: 8px;
  }

  /* 状态列 */
  .card-table th:nth-child(6),
  .card-table td:nth-child(6) {
    width: 28px;
    min-width: 28px;
    font-size: 8px;
  }

  /* 生成时间 */
  .card-table th:nth-child(7),
  .card-table td:nth-child(7) {
    width: 38px;
    min-width: 38px;
    font-size: 6px;
  }

  /* 使用时间 */
  .card-table th:nth-child(8),
  .card-table td:nth-child(8) {
    width: 38px;
    min-width: 38px;
    font-size: 6px;
  }

  /* 图片制作 */
  .card-table th:nth-child(9),
  .card-table td:nth-child(9) {
    width: 28px;
    min-width: 28px;
    font-size: 8px;
  }

  /* 反馈状态样式 */
  .status-pending {
    color: #ff9800;
    font-weight: bold;
  }
  .status-processing {
    color: #2196f3;
    font-weight: bold;
  }
  .status-resolved {
    color: #4caf50;
    font-weight: bold;
  }
  .status-closed {
    color: #999;
  }

  /* 反馈表格样式 */
  .feedback-table th,
  .feedback-table td {
    font-size: 13px;
  }

  .btn-small {
    padding: 3px 8px;
    font-size: 12px;
    border: none;
    border-radius: 3px;
    background-color: #4a67fb;
    color: white;
    cursor: pointer;
  }

  .btn-small:hover {
    background-color: #3a57eb;
  }
}

/* 反馈图片样式 */
.feedback-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.feedback-image-item {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ddd;
  cursor: zoom-in;
}

.feedback-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.2s;
}

.feedback-image-item img:hover {
  transform: scale(1.05);
}

/* ========== 消息通知样式 ========== */

.message-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #f44336;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
  min-width: 18px;
  text-align: center;
}

/* 用户身份角标样式 */
.user-badge {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #fff;
  border-radius: 10px;
  padding: 1px 6px;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.message-modal-container {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.message-item.unread {
  background-color: #f0f7ff;
}

/* ========== 反馈弹窗样式 ========== */
.feedback-modal-container {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.feedback-modal-container h3 {
  margin: 0 0 10px 0;
  color: #333;
  text-align: center;
  font-size: 20px;
}

.feedback-modal-container .modal-desc {
  color: #666;
  font-size: 14px;
  text-align: center;
  margin-bottom: 25px;
}

.feedback-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feedback-form-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.feedback-label {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  gap: 4px;
}

.feedback-label .required {
  color: #f44336;
}

.feedback-label .optional {
  color: #999;
  font-weight: normal;
  font-size: 13px;
}

.feedback-textarea,
.feedback-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.3s;
}

.feedback-textarea:focus,
.feedback-input:focus {
  outline: none;
  border-color: #4a67fb;
}

.feedback-textarea {
  resize: vertical;
  min-height: 100px;
}

/* 图片上传区域样式 */
.image-upload-wrapper {
  display: flex;
  align-items: stretch;
  gap: 10px;
}

.image-upload-area {
  flex: 1;
  border: 2px dashed #ddd;
  border-radius: 6px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s;
  min-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-image-btn {
  width: 100px;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  background-color: #f5f7fa;
  border: 2px solid #e4e7ed;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 13px;
  color: #606266;
}

.upload-image-btn:hover {
  background-color: #ecf5ff;
  border-color: #4a67fb;
  color: #4a67fb;
}

.upload-image-btn span:first-child {
  font-size: 24px;
}

.image-upload-area:hover,
.image-upload-area:focus {
  border-color: #4a67fb;
  outline: none;
}

.upload-placeholder {
  color: #999;
}

.upload-placeholder p {
  margin: 5px 0;
}

.image-preview-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.image-preview-item {
  position: relative;
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #ddd;
}

.image-preview-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.remove-image-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  background-color: rgba(244, 67, 54, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-more-images {
  width: 80px;
  height: 80px;
  border: 2px dashed #ddd;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  transition: border-color 0.3s;
}

.add-more-images:hover {
  border-color: #4a67fb;
  color: #4a67fb;
}

.add-more-images span {
  font-size: 24px;
  line-height: 1;
}

.add-more-images p {
  margin: 5px 0 0 0;
  font-size: 12px;
}

.image-count-hint {
  font-size: 12px;
  color: #666;
  margin: 5px 0 0 0;
}

/* 反馈弹窗按钮 */
.feedback-modal-buttons {
  display: flex;
  gap: 12px;
  margin-top: 25px;
}

.feedback-btn-cancel,
.feedback-btn-confirm {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s;
}

.feedback-btn-cancel {
  background-color: #f0f0f0;
  color: #666;
}

.feedback-btn-cancel:hover {
  background-color: #e0e0e0;
}

.feedback-btn-confirm {
  background-color: #4a67fb;
  color: white;
}

.feedback-btn-confirm:hover:not(:disabled) {
  background-color: #3a57eb;
}

.feedback-btn-confirm:disabled {
  background-color: #a5b4fc;
  cursor: not-allowed;
}
</style>

